module.exports = __webpack_public_path__ + "media/nic/bghead-50bbd384.png";